module.exports = __webpack_public_path__ + "static/media/emptyStateJournal.bde33b65.svg";